import { render, staticRenderFns } from "./PaginationW.vue?vue&type=template&id=8457d40c&"
import script from "./PaginationW.vue?vue&type=script&lang=js&"
export * from "./PaginationW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports